import type { PortalStrings } from "./en";

export const hi: PortalStrings = {
  shell: {
    portal: "क्लाइंट पोर्टल",
    nav: {
      home: "होम",
      case: "मेरा केस",
      caseShort: "केस",
      tasks: "काम",
      documents: "दस्तावेज़",
      profile: "मेरी प्रोफ़ाइल",
      profileShort: "प्रोफ़ाइल"
    },
    signOut: "साइन आउट करें",
    language: "भाषा",
    previewing:
      "आप {{name}} का पोर्टल वैसे ही देख रहे हैं जैसे वे देखते हैं। सिर्फ़ देखने के लिए: यहाँ कुछ भी सेव या भेजा नहीं जाता।",
    exitPreview: "प्रीव्यू बंद करें",
    privacy: "आपकी जानकारी सिर्फ़ आप और आपकी कानूनी टीम देख सकती है।",
    notClient: "इस खाते के लिए क्लाइंट पोर्टल सेट नहीं है",
    notClientBody:
      "अपनी कानूनी टीम से आपको आमंत्रित करने के लिए कहें, या उस ईमेल से साइन इन करें जिस पर आमंत्रण आया था।",
    useDifferentEmail: "दूसरा ईमेल इस्तेमाल करें",
    cantPreview: "इस पोर्टल का प्रीव्यू नहीं देखा जा सकता",
    loadFailed: "हम आपका पोर्टल लोड नहीं कर सके। थोड़ी देर में फिर कोशिश करें।",
    retry: "फिर कोशिश करें"
  },
  greeting: {
    morning: "सुप्रभात, {{name}}",
    afternoon: "नमस्ते, {{name}}",
    evening: "शुभ संध्या, {{name}}",
    withTasks_one: "हमें आपसे बस यह एक चीज़ चाहिए।",
    withTasks_other: "हमें आपसे ये चीज़ें चाहिए।",
    stageLine: {
      started: "आपका मामला शुरू हो रहा है।",
      gathering: "हम आपके मामले के लिए जानकारी जुटा रहे हैं।",
      review: "आपके वकील आपके मामले की समीक्षा कर रहे हैं।",
      filed: "आपका मामला USCIS में दाखिल कर दिया गया है।",
      decision: "आपका मामला निर्णय के चरण में है।"
    },
    allCaughtUp:
      "अभी आपके लिए कुछ बाकी नहीं है। जब हमें कुछ चाहिए होगा, हम आपको बताएँगे।"
  },
  tasks: {
    title: "हमें आपसे क्या चाहिए",
    count_one: "1 काम",
    count_other: "{{count}} काम",
    none: "अभी कुछ नहीं",
    noneBody: "जब आपकी कानूनी टीम को आपसे कुछ चाहिए होगा, वह यहाँ दिखेगा।",
    progress: "{{total}} में से {{answered}} के जवाब दिए गए",
    minutesLeft_one: "लगभग 1 मिनट बाकी",
    minutesLeft_other: "लगभग {{count}} मिनट बाकी",
    due: "{{date}} तक",
    dueToday: "आज तक",
    overdue: "{{date}} तक करना था",
    changesRequested: "आपकी कानूनी टीम ने कुछ जवाब अपडेट करने को कहा है",
    start: "शुरू करें",
    continue: "जारी रखें",
    update: "जवाब अपडेट करें",
    opening: "खुल रहा है…",
    openFailed:
      "हम यह काम नहीं खोल सके। अपने ईमेल वाला लिंक इस्तेमाल करें, या फिर कोशिश करें।",
    previewOnly: "काम सिर्फ़ क्लाइंट के लिए खुलते हैं।",
    sign: "पढ़ें और साइन करें",
    ink: "शुरू करें",
    notYet: "अभी नहीं",
    signMeta: "लगभग {{minutes}} मिनट",
    inkMeta:
      "प्रिंट करें, स्याही से साइन करें, फ़ोटो भेजें · लगभग {{minutes}} मिनट",
    upcoming: "आपके साइन के लिए तैयार होने पर खुलेगा",
    sendAgain: "आपकी कानूनी टीम ने इसे दोबारा भेजने को कहा है"
  },
  case: {
    title: "आपका केस",
    titlePlural: "आपके केस",
    fullTimeline: "पूरी टाइमलाइन",
    now: "अभी क्या हो रहा है",
    onHold:
      "आपका केस अभी रुका हुआ है। जब काम फिर शुरू होगा, आपकी कानूनी टीम आपको बताएगी।",
    approved: "मंज़ूर",
    decision: "निर्णय हो गया",
    receipts: "USCIS रसीदें",
    noReceipts: "USCIS रसीद भेजते ही आपका रसीद नंबर यहाँ दिखेगा।",
    checkStatus: "USCIS स्टेटस देखें",
    checking: "देखा जा रहा है…",
    checkedAt: "{{when}} देखा गया",
    statusFailed: "USCIS अभी जवाब नहीं दे रहा है। बाद में फिर कोशिश करें।",
    details: "केस की जानकारी",
    caseType: "केस का प्रकार",
    opened: "खोला गया",
    priorityDate: "प्राथमिकता तिथि",
    updates: "अपडेट",
    noUpdates: "आपके केस के अपडेट यहाँ दिखेंगे।",
    none: "अभी कोई केस नहीं",
    noneBody:
      "जब आपकी कानूनी टीम आपका केस खोलेगी, आप उसकी प्रगति यहाँ देख सकेंगे।",
    back: "सभी केस",
    notFound: "हमें यह केस नहीं मिला।",
    step: "चरण {{n}} / {{total}}",
    startedOn: "{{date}} को शुरू हुआ",
    nowChip: "अभी",
    waitingOnYou: "आपका इंतज़ार है",
    open: "खोलें",
    attorney: "वकील",
    receiptNumber: "रसीद नंबर",
    receiptLater: "दायर होने के बाद यहाँ दिखेगा",
    priorityLater: "USCIS को मिलने पर तय होती है",
    questions: "अपने केस के बारे में कोई सवाल?",
    emailLead: "{{name}} को ईमेल करें"
  },
  milestone: {
    rfe: "USCIS ने और सबूत माँगे हैं (Request for Evidence, RFE)। {{lead}} जवाब तैयार कर रहे हैं और अगर आपसे कुछ चाहिए होगा तो बताएँगे।",
    interview:
      "USCIS ने इंटरव्यू तय किया है। {{lead}} तैयारी में आपकी मदद करेंगे और बताएँगे कि क्या साथ लाना है।",
    biometrics:
      "USCIS बायोमेट्रिक्स चरण में है: USCIS ऑफ़िस में उंगलियों के निशान और फ़ोटो। अपना अपॉइंटमेंट नोटिस और फ़ोटो वाला पहचान पत्र साथ लाएँ।"
  },
  stageAbout: {
    started:
      "आपकी कानूनी टीम आपका केस खोलती है और तय करती है कि उसे आपसे क्या चाहिए।",
    gathering:
      "हम आपके जवाब और दस्तावेज़ इकट्ठा करते हैं: आप कौन हैं, आपका इतिहास, और आपके केस के लिए ज़रूरी सबूत।",
    review:
      "आपके वकील सब कुछ जाँचते हैं, आपके फ़ॉर्म और पत्र तैयार करते हैं, और आपसे कुछ और सवाल पूछ सकते हैं।",
    filed:
      "हम आपका केस USCIS को भेजते हैं। USCIS रसीद भेजते ही रसीद नंबर यहाँ दिखेगा, और आप इसी पेज से स्टेटस देख सकेंगे।",
    decision:
      "USCIS केस मंज़ूर करता है, और सबूत माँगता है (Request for Evidence), या उसे नामंज़ूर करता है। हम आपको बताएँगे कि आगे क्या होगा।"
  },
  stage: {
    started: "शुरुआत",
    gathering: "जानकारी इकट्ठा करना",
    review: "वकील की समीक्षा",
    filed: "USCIS में दायर",
    decision: "निर्णय"
  },
  explainer: {
    yourTeam: "आपकी कानूनी टीम",
    yourTeamLower: "आपकी कानूनी टीम",
    started:
      "{{lead}} आपका केस तैयार कर रहे हैं। हमें आपसे जो भी चाहिए, वह इसी पेज पर दिखेगा।",
    gathering:
      "{{lead}} आपके जवाब और दस्तावेज़ इकट्ठा कर रहे हैं। सब मिल जाने के बाद {{leadFirst}} सब कुछ जाँचेंगे और आपकी फ़ाइलिंग तैयार करना शुरू करेंगे।",
    review:
      "{{lead}} आपकी जानकारी की समीक्षा कर रहे हैं और आपकी फ़ाइलिंग तैयार कर रहे हैं। आपसे कुछ और सवाल पूछे जा सकते हैं।",
    filed:
      "आपका केस USCIS में दायर कर दिया गया है। USCIS आम तौर पर पहले रसीद नोटिस डाक से भेजता है और फिर बायोमेट्रिक्स अपॉइंटमेंट तय कर सकता है। प्रक्रिया का समय केस के प्रकार पर निर्भर करता है।",
    decision:
      "USCIS ने आपके केस पर निर्णय ले लिया है। {{lead}} आपको बताएँगे कि इसका क्या मतलब है और आगे क्या करना है।"
  },
  updates: {
    opened: "आपका केस खोला गया",
    filed: "आपका केस USCIS में दायर किया गया",
    approved: "USCIS ने आपका केस मंज़ूर किया",
    decided: "USCIS ने आपके केस पर निर्णय लिया",
    reopened: "आपका केस फिर से खोला गया",
    receipt: "USCIS रसीद {{receipt}} जोड़ी गई",
    receipt_unnamed: "एक USCIS रसीद जोड़ी गई",
    questions_sent: "हमने आपको जवाब देने के लिए सवाल भेजे",
    answers_received: "हमें आपके जवाब मिल गए",
    changes_requested: "हमने आपसे कुछ जवाब अपडेट करने को कहा",
    answers_reviewed: "आपके जवाबों की समीक्षा हो गई"
  },
  comingUp: {
    title: "आने वाला",
    taskDue: "{{title}} की आखिरी तारीख",
    allDay: "पूरा दिन"
  },
  team: {
    title: "आपकी कानूनी टीम",
    email: "{{name}} को ईमेल करें"
  },
  reminders: {
    title: "ध्यान रखें",
    expiresIn_one: "{{subject}} कल समाप्त हो रहा है",
    expiresIn_other: "{{subject}} {{count}} दिनों में समाप्त हो रहा है",
    expiresToday: "{{subject}} आज समाप्त हो रहा है",
    expired: "{{subject}}: रिकॉर्ड में समाप्ति तिथि {{date}} थी",
    expiresHint:
      "इसे रिन्यू करने या कोई यात्रा तय करने से पहले अपनी कानूनी टीम को बताएँ।",
    expiredHint:
      "अगर आपको नया दस्तावेज़ मिल गया है, तो उसे अपलोड करें ताकि आपकी कानूनी टीम के पास रहे।",
    yours: {
      status: "आपका {{status}} स्टेटस",
      immigration_status_expiration: "आपका इमिग्रेशन स्टेटस",
      i94_expiration: "आपका I-94",
      passport_expiration: "आपका पासपोर्ट",
      ead_expiration: "आपका वर्क परमिट (EAD)",
      advance_parole_expiration: "आपका एडवांस पैरोल",
      visa_expiration: "आपका वीज़ा"
    },
    theirs: {
      immigration_status_expiration: "{{name}} का इमिग्रेशन स्टेटस",
      i94_expiration: "{{name}} का I-94",
      passport_expiration: "{{name}} का पासपोर्ट",
      ead_expiration: "{{name}} का वर्क परमिट (EAD)",
      advance_parole_expiration: "{{name}} का एडवांस पैरोल",
      visa_expiration: "{{name}} का वीज़ा"
    }
  },
  documents: {
    title: "दस्तावेज़",
    subtitle:
      "आपने हमें जो भेजा है और आपकी कानूनी टीम ने आपके साथ जो शेयर किया है।",
    upload: "दस्तावेज़ अपलोड करें",
    takePhoto: "फ़ोटो लें",
    uploading: "{{name}} अपलोड हो रहा है…",
    uploaded: "{{name}} आपकी कानूनी टीम को भेज दिया गया",
    uploadFailed: "{{name}} अपलोड नहीं हुआ। फिर कोशिश करें।",
    fromYou: "आपकी ओर से",
    fromTeam: "आपकी कानूनी टीम की ओर से",
    open: "खोलें",
    remove: "हटाएँ",
    removed: "{{name}} हटा दिया गया",
    removeFailed: "हटाया नहीं जा सका। फिर कोशिश करें।",
    none: "अभी कोई दस्तावेज़ नहीं",
    noneBody:
      "आपकी कानूनी टीम जो दस्तावेज़ माँगे उन्हें अपलोड करें, या उनकी शेयर की गई फ़ाइलें देखने के लिए बाद में आएँ।",
    previewOnly: "प्रीव्यू में अपलोड बंद हैं।",
    checking: "{{name}} जाँच रहे हैं…",
    looksGood: "{{name}} ठीक दिख रहा है",
    weRead: "हमने इसमें यह पढ़ा:",
    mayBeHard: "{{name}} पढ़ने में मुश्किल हो सकता है",
    replace: "बदलें",
    keep: "रखें"
  },
  sign: {
    from: "{{name}} की ओर से",
    inkWhy:
      "USCIS को काग़ज़ी फ़ॉर्म पर हाथ से किया गया साइन चाहिए, इसलिए इस पेज पर स्क्रीन पर साइन नहीं हो सकता।",
    read: "दस्तावेज़ पढ़ें",
    readHint: "साइन करने से पहले हर पेज पढ़ें।",
    add: "अपना साइन जोड़ें",
    draw: "बनाएँ",
    type: "टाइप करें",
    drawHint: "उँगली या माउस से यहाँ साइन करें",
    clear: "मिटाएँ",
    fullName: "आपका पूरा नाम",
    consent:
      "मैं इस दस्तावेज़ पर इलेक्ट्रॉनिक रूप से साइन करने के लिए सहमत हूँ, और मेरा इलेक्ट्रॉनिक साइन मेरे हाथ से किए गए साइन के बराबर माना जाएगा।",
    signAndSend: "साइन करें और {{name}} को भेजें",
    signing: "साइन हो रहा है…",
    audit:
      "हम आपको साइन की हुई कॉपी ईमेल करते हैं। आपका साइन, समय और दस्तावेज़ का फ़िंगरप्रिंट दर्ज किया जाता है ताकि बाद में इसकी जाँच हो सके।",
    needSignature: "पहले अपना साइन बनाएँ या टाइप करें।",
    needConsent: "इलेक्ट्रॉनिक साइन के लिए सहमति देने का बॉक्स चुनें।",
    failed: "साइन नहीं हो सका। फिर से कोशिश करें।",
    signed: "साइन हो गया",
    signedBody: "आपने {{date}} को साइन किया। हमने आपको एक कॉपी ईमेल की है।",
    signedNoCopy: "आपने {{date}} को साइन किया।",
    downloadSigned: "साइन की हुई कॉपी डाउनलोड करें",
    print: "पेज प्रिंट करें",
    download: "साइन करने वाला पेज डाउनलोड करें (PDF)",
    noPrinter: "प्रिंटर नहीं है? अपनी कानूनी टीम से इसे डाक से भेजने को कहें।",
    inkSign: "काली स्याही से साइन करें",
    inkBox: "पेज {{page}} पर “{{box}}” वाले बॉक्स में साइन करें।",
    inkBoxPage: "पेज {{page}} पर साइन वाले बॉक्स में साइन करें।",
    photo: "साइन किए हुए पेज की फ़ोटो लें",
    photoHint: "पेज को समतल रखें, अच्छी रोशनी में, और पूरा पेज दिखना चाहिए।",
    takePhoto: "फ़ोटो लें",
    chooseFile: "फ़ाइल चुनें",
    retake: "फिर से लें",
    checking: "आपकी फ़ोटो जाँच रहे हैं…",
    found: "बॉक्स में साइन मिल गया",
    notFound: "हमें बॉक्स में साइन नहीं दिखा",
    readable: "पूरा पेज दिख रहा है और पढ़ा जा सकता है",
    notReadable: "पेज का कुछ हिस्सा पढ़ने में मुश्किल है",
    unchecked: "हम यह फ़ोटो जाँच नहीं सके, लेकिन आप इसे फिर भी भेज सकते हैं।",
    send: "{{name}} को भेजें",
    sendAnyway: "फिर भी भेजें",
    sending: "भेज रहे हैं…",
    uploadFailed: "फ़ोटो अपलोड नहीं हुई। फिर से कोशिश करें।",
    keepOriginal:
      "मूल कॉपी अपने पास रखें। {{name}} इसे डाक से भेजने को कह सकते हैं।",
    sent: "{{name}} को भेज दिया गया",
    sentBody:
      "{{name}} इसे जाँचेंगे और कुछ और चाहिए तो बताएँगे। मूल कॉपी अपने पास रखें।",
    completed: "हो गया",
    completedBody: "{{name}} ने आपका साइन किया हुआ पेज स्वीकार कर लिया।",
    returned: "{{name}} ने इसे दोबारा भेजने को कहा है:",
    upcoming: "अभी तैयार नहीं है",
    upcomingBody: "आपके साइन के लिए तैयार होने पर {{name}} आपको बताएँगे।",
    gone: "इस दस्तावेज़ पर अब आपके साइन की ज़रूरत नहीं है।",
    back: "कामों पर वापस जाएँ",
    previewOnly: "प्रीव्यू में साइन करना बंद है।",
    viewer: "साइन करने वाला दस्तावेज़",
    changed:
      "भेजे जाने के बाद यह दस्तावेज़ बदल गया। आपकी कानूनी टीम इसे दोबारा भेजेगी।"
  },
  profile: {
    subtitle:
      "यही जानकारी आपके इमिग्रेशन फ़ॉर्म में जाती है। अगर कुछ गलत है या बदल गया है, तो सुधार का सुझाव दें और {{name}} उसकी समीक्षा करेंगे।",
    about: "आपके बारे में",
    contact: "हम आपसे कैसे संपर्क करें",
    lived: "आप कहाँ रहे हैं",
    worked: "आपने कहाँ काम किया है",
    studied: "आपकी पढ़ाई",
    noneOnFile: "अभी कुछ दर्ज नहीं है",
    notOnFile: "दर्ज नहीं",
    historyHint: "यहाँ कुछ छूटा है या गलत है?",
    tellUs: "{{name}} को बताएँ",
    suggest: "सुधार का सुझाव दें",
    add: "जोड़ें",
    waiting: "{{name}} की समीक्षा का इंतज़ार",
    withdraw: "वापस लें",
    withdrawn: "सुझाव वापस ले लिया गया",
    updated: "अपडेट किया गया",
    kept: "{{name}} ने दर्ज जानकारी ही रखी।",
    keptWhy: "{{name}} ने दर्ज जानकारी ही रखी: {{reason}}",
    note: "{{name}} को कुछ बताना है?",
    notePlaceholder: "उदाहरण: मेरे पासपोर्ट में सही स्पेलिंग है।",
    addressPlaceholder: "अगर आप घर बदल चुके हैं, तो बताएँ कब।",
    historyLabel: "क्या छूटा है या गलत है?",
    historyPlaceholder:
      "उदाहरण: मैं जून 2019 से मई 2020 तक 12 Elm St, Austin, TX में रहा/रही।",
    yourNotes: "आपके भेजे गए नोट",
    attach: "दस्तावेज़ जोड़ें",
    attachHint: "सही जानकारी दिखाने वाली फ़ोटो या PDF।",
    attaching: "{{name}} अपलोड हो रहा है…",
    attachFailed: "वह फ़ाइल अपलोड नहीं हुई। फिर कोशिश करें।",
    removeAttachment: "अटैचमेंट हटाएँ",
    cancel: "रद्द करें",
    send: "{{name}} को भेजें",
    sending: "भेजा जा रहा है…",
    sent: "समीक्षा के लिए {{name}} को भेजा गया",
    failed: "भेजा नहीं जा सका। फिर कोशिश करें।",
    unchanged: "यही जानकारी पहले से दर्ज है। पहले कोई बदलाव करें।",
    previewOnly: "प्रीव्यू में सुझाव बंद हैं।",
    present: "अब तक",
    topic: {
      legal_name: "कानूनी नाम",
      other_names: "आपके इस्तेमाल किए गए दूसरे नाम",
      birthday: "जन्म तिथि",
      birthplace: "जन्म स्थान",
      citizenships: "नागरिकता",
      marital_status: "वैवाहिक स्थिति",
      email: "ईमेल",
      phone: "फ़ोन",
      physical_address: "घर का पता",
      mailing_address: "डाक का पता",
      history: "आपका इतिहास"
    },
    field: {
      first_name: "पहला नाम",
      middle_name: "मध्य नाम",
      last_name: "उपनाम",
      other_names: "दूसरे नाम, कॉमा से अलग करें",
      birthday: "जन्म तिथि",
      city_of_birth: "शहर",
      state_of_birth: "राज्य या प्रांत",
      country_of_birth: "देश",
      citizenships: "देश, कॉमा से अलग करें",
      marital_status: "वैवाहिक स्थिति",
      email: "ईमेल",
      phone: "फ़ोन",
      street: "सड़क और मकान नंबर",
      city: "शहर",
      state: "राज्य",
      zip_code: "ZIP या पिन कोड",
      country: "देश"
    },
    marital: {
      single: "अविवाहित, कभी शादी नहीं हुई",
      married: "विवाहित",
      divorced: "तलाकशुदा",
      widowed: "विधवा/विधुर",
      separated: "कानूनी रूप से अलग",
      annulled: "विवाह रद्द"
    }
  },
  signIn: {
    title: "अपने पोर्टल में साइन इन करें",
    sentTitle: "अपना ईमेल देखें",
    email: "ईमेल",
    send: "मुझे साइन-इन लिंक ईमेल करें",
    sending: "भेजा जा रहा है…",
    hint: "पासवर्ड की ज़रूरत नहीं है। हम इस ईमेल पर एक लिंक भेजेंगे जिससे आप साइन इन हो जाएँगे।",
    sent: "अगर {{email}} का क्लाइंट पोर्टल है, तो साइन-इन लिंक भेज दिया गया है। यह सिर्फ़ एक बार काम करता है और एक घंटे में समाप्त हो जाता है।",
    sendAnother: "दूसरा ईमेल इस्तेमाल करें",
    failed: "लिंक नहीं भेजा जा सका। एक मिनट बाद फिर कोशिश करें।",
    staff: "किसी लॉ फ़र्म में काम करते हैं?",
    staffLink: "यहाँ साइन इन करें"
  },
  welcome: {
    signingIn: "साइन इन हो रहा है…",
    expired: "यह लिंक समाप्त हो गया है",
    used: "यह लिंक पहले ही इस्तेमाल हो चुका है",
    invalid: "यह लिंक मान्य नहीं है",
    revoked: "यह लिंक अब काम नहीं करता",
    off: "पोर्टल एक्सेस बंद है",
    offBody: "अपनी कानूनी टीम से इसे फिर चालू करने के लिए कहें।",
    getNew: "अपना ईमेल डालें और हम आपको नया साइन-इन लिंक भेजेंगे।"
  },
  intake: {
    language: "भाषा",
    showEnglish: "अंग्रेज़ी में देखें",
    showTranslated: "{{language}} में देखें",
    translating: "सवालों का अनुवाद हो रहा है…",
    translationFailed:
      "अभी सवालों का अनुवाद नहीं हो सका, इसलिए वे अंग्रेज़ी में हैं।",
    answerHint:
      "हो सके तो अंग्रेज़ी में जवाब दें। नहीं तो अपनी भाषा में जवाब दें, आपकी कानूनी टीम अनुवाद कर लेगी।",
    defaultNote:
      "यह प्रश्नावली आराम से भरें। ध्यान रखें कि सारी जानकारी आपके आधिकारिक दस्तावेज़ों से मेल खाए।",
    defaultTitle: "इमिग्रेशन क्लाइंट प्रश्नावली",
    start: "शुरू करें",
    resume: "जारी रखें",
    fix_one: "{{count}} जवाब ठीक करें →",
    fix_other: "{{count}} जवाब ठीक करें →",
    takes_one: "लगभग {{count}} मिनट लगेगा",
    takes_other: "लगभग {{count}} मिनट लगेंगे",
    left_one: "लगभग {{count}} मिनट बाकी",
    left_other: "लगभग {{count}} मिनट बाकी",
    about_one: "लगभग {{count}} मिनट",
    about_other: "लगभग {{count}} मिनट",
    othersSaved_one: " · बाकी 1 जवाब सेव है",
    othersSaved_other: " · बाकी {{count}} जवाब सेव हैं",
    needsChanges_one: "आपके वकील ने आपके जवाब देखे हैं और एक बदलाव चाहिए।",
    needsChanges_other:
      "आपके वकील ने आपके जवाब देखे हैं और {{count}} बदलाव चाहिए।",
    attorney: "वकील",
    yourAttorney: "आपके वकील",
    yourAttorneyLower: "आपके वकील",
    yourFirm: "आपकी लॉ फ़र्म",
    you: "आप",
    welcomeBack: "फिर से स्वागत है",
    welcomeBackName: "फिर से स्वागत है, {{name}}।",
    resumeBody:
      "आप यह प्रश्नावली पहले ही शुरू कर चुके हैं। क्या आप वहीं से जारी रखना चाहेंगे जहाँ छोड़ा था?",
    continueWhereLeft: "जहाँ छोड़ा था वहीं से जारी रखें",
    reviewFromStart: "शुरू से देखें",
    ok: "ठीक है",
    skip: "छोड़ें",
    continue: "जारी रखें",
    submit: "जमा करें",
    sendTo: "{{name}} को भेजें",
    yes: "हाँ",
    no: "नहीं",
    previousStep: "पिछला चरण",
    nextStep: "अगला चरण",
    displaySettings: "डिस्प्ले सेटिंग",
    typeAnswer: "अपना जवाब यहाँ लिखें...",
    yourAnswer: "आपका जवाब",
    typeOrSelect: "लिखें या कोई विकल्प चुनें",
    noMatches: "कोई मिलता-जुलता विकल्प नहीं",
    street: "सड़क का पता",
    city: "शहर",
    state: "राज्य / प्रांत",
    statePlaceholder: "राज्य",
    postal: "पिन / ZIP कोड",
    postalPlaceholder: "पिन कोड",
    country: "देश",
    dragDrop: "अपनी फ़ाइलें यहाँ खींचकर छोड़ें",
    uploadingShort: "अपलोड हो रहा है...",
    upload: "अपलोड करें",
    uploadMore: "और अपलोड करें",
    uploadedFiles: "अपलोड की गई फ़ाइलें",
    uploadingDocument: "दस्तावेज़ अपलोड हो रहा है",
    uploaded: "अपलोड हो गया",
    uploadedBody_one: "आपकी फ़ाइल अपलोड हो गई।",
    uploadedBody_other: "{{count}} फ़ाइलें अपलोड हो गईं।",
    someFailed: "कुछ फ़ाइलें अपलोड नहीं हुईं",
    uploadFailed: "अपलोड नहीं हुआ",
    pleaseTryAgain: "फिर कोशिश करें।",
    saved: "सेव हो गया",
    savedBody: "आप यह पेज बंद करके बाद में इसी लिंक से वापस आ सकते हैं।",
    couldntSave: "सेव नहीं हो सका",
    submitted: "जमा हो गया",
    submittedBody: "आपके जवाब भेज दिए गए।",
    couldntSubmit: "जमा नहीं हो सका",
    thankYou: "धन्यवाद!",
    thankYouBody:
      "आपकी कानूनी टीम को आपके जवाब मिल गए हैं और वे जल्द ही उनकी समीक्षा करेंगे। अब आप यह टैब बंद कर सकते हैं।",
    review: "अपने जवाब जाँचें",
    reviewBody:
      "जमा करने से पहले अपने जवाब जाँच लें। जो बदलना हो, उसे आप बदल सकते हैं।",
    reviewGroupBody:
      "आप कोई भी एंट्री बदल या हटा सकते हैं, या नई जोड़ सकते हैं।",
    edit: "बदलें",
    remove: "हटाएँ",
    notAnswered: "जवाब नहीं दिया",
    notProvided: "नहीं दिया गया",
    noEntries: "कोई एंट्री नहीं।",
    noEntriesAdded: "कोई एंट्री नहीं जोड़ी गई।",
    noEntriesYet: "अभी कोई एंट्री नहीं जोड़ी गई।",
    noEntriesSubmitted: "कोई एंट्री जमा नहीं की गई।",
    noDetails: "अभी कोई जानकारी नहीं दी गई।",
    noDocChanges: "दस्तावेज़ों में कोई बदलाव नहीं माँगा गया।",
    noDocs: "कोई दस्तावेज़ उपलब्ध नहीं।",
    leaveComment: "टिप्पणी लिखें...",
    addComment: "टिप्पणी जोड़ें",
    addReply: "जवाब दें",
    cancel: "रद्द करें",
    youSent: "आपने भेजा",
    youAnswered: "आपका जवाब:",
    addAnother: "एक और जोड़ें?",
    loadFailed: "प्रश्नावली लोड नहीं हो सकी",
    oops: "माफ़ करें, कुछ गड़बड़ हो गई।",
    persists: "अगर समस्या बनी रहे, तो अपनी लॉ फ़र्म से संपर्क करें।",
    tryAgain: "फिर कोशिश करें",
    attention_one: "एक फ़ाइल पर ध्यान देना ज़रूरी है",
    attention_other: "{{count}} फ़ाइलों पर ध्यान देना ज़रूरी है",
    attentionBody: "आपके वकील आपसे इन्हें फिर से भेजने को कह सकते हैं।",
    sendAnyway: "फिर भी भेजें",
    savesAuto: "आपकी प्रगति अपने आप सहेजी जाती है",
    prefilledCount_one: "{{count}} जवाब पहले से भरा है",
    prefilledCount_other: "{{count}} जवाब पहले से भरे हैं",
    progressOf: "{{total}} में से {{current}}",
    savedAt: "सहेजा गया {{time}}",
    backToPortal: "अपने पोर्टल पर वापस जाएँ",
    outline: {
      questions_one: "{{count}} सवाल",
      questions_other: "{{count}} सवाल",
      filled_one: "{{count}} भरा हुआ",
      filled_other: "{{count}} भरे हुए",
      minutes_one: "{{count}} मिनट",
      minutes_other: "{{count}} मिनट",
      done: "पूरा"
    },
    prefill: {
      ask: "क्या यह सही है?",
      yes: "हाँ, यह सही है",
      change: "इसे बदलें",
      fromDocs: "आपके दस्तावेज़ों से",
      onFile: "हमारे रिकॉर्ड में पहले से है"
    },
    date: {
      day: "दिन",
      month: "महीना",
      year: "साल",
      pickMonth: "महीना चुनें",
      echo: "आपने लिखा: {{date}}",
      invalid: "यह तारीख़ मौजूद नहीं है। दिन और महीना जाँचें।"
    },
    ph: {
      email: "name@example.com",
      phone: "+1 555 123 4567",
      givenName: "जैसा आपके पासपोर्ट पर है",
      familyName: "जैसा आपके पासपोर्ट पर है",
      middleName: "अगर नहीं है तो खाली छोड़ दें",
      otherNames: "आपने जो दूसरे नाम इस्तेमाल किए हैं",
      fullName: "पूरा नाम",
      number: "जैसा दस्तावेज़ पर छपा है",
      city: "शहर",
      country: "देश",
      employer: "कंपनी या संस्था",
      jobTitle: "आपका पद",
      school: "स्कूल या विश्वविद्यालय",
      website: "https://",
      longText: "अपना जवाब यहाँ लिखें…",
      answer: "अपना जवाब यहाँ लिखें…"
    },
    group: {
      tellUs: "हमें अपने {{name}} के बारे में बताएँ।",
      tellUsAddresses: "हमें अपने पतों के इतिहास के बारे में बताएँ।",
      tellUsEmployment: "हमें अपनी नौकरियों के इतिहास के बारे में बताएँ।",
      tellUsStatuses: "हमें अपने इमिग्रेशन स्टेटस के इतिहास के बारे में बताएँ।",
      tellUsTrips: "हमें अमेरिका में अपने आने-जाने के बारे में बताएँ।",
      tellUsDependents: "हमें अपने आश्रितों के बारे में बताएँ।",
      leadIn: "क्या आपको {{name}} में कुछ जोड़ना है?",
      leadInAddresses: "क्या आपको कोई पिछला पता जोड़ना है?",
      leadInEmployment: "क्या आपको कोई पिछली नौकरी जोड़नी है?",
      leadInStatuses: "क्या आपको कोई पिछला इमिग्रेशन स्टेटस जोड़ना है?",
      leadInTrips: "क्या आपको अमेरिका में आने-जाने की कोई जानकारी जोड़नी है?",
      addAnother: "एक और {{name}} जोड़ें?",
      addAnotherAddress: "एक और पता जोड़ें?",
      addAnotherEmployer: "एक और नियोक्ता जोड़ें?",
      addAnotherStatus: "एक और स्टेटस जोड़ें?",
      addAnotherTrip: "एक और यात्रा जोड़ें?",
      review: "अपने {{name}} जाँचें",
      reviewAddresses: "अपने पते जाँचें",
      reviewEmployers: "अपने नियोक्ता जाँचें",
      reviewStatuses: "अपने स्टेटस जाँचें",
      reviewTrips: "अपनी यात्राएँ जाँचें",
      entries: "एंट्री"
    }
  },
  common: {
    loading: "लोड हो रहा है…",
    today: "आज",
    yesterday: "कल",
    daysAgo_one: "1 दिन पहले",
    daysAgo_other: "{{count}} दिन पहले"
  }
};
